// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 1l4 4 4-4%27 stroke=%27%2393A9BC%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   HelpExamples.css  —  KinetiQ  ·  Help → Examples
   ------------------------------------------------------------
   Companion stylesheet to DataFittingPage.css. Prefix is \`hx-\`
   (DataFittingPage owns \`df-\`), so the two can be loaded
   together on the same document with no collisions.

   DEPENDENCY — this file deliberately defines NO design tokens.
   Every --color-*, --space-*, --radius-*, --fs-*, --font-* and
   --sidebar-w it consumes is declared in DataFittingPage.css's
   :root / [data-theme] blocks. That is what makes this page
   re-theme automatically when data-theme flips on <html>.
   Import DataFittingPage.css first, or hoist those blocks into
   a shared tokens.css. Fallbacks are supplied on the few
   tokens not present in every older build.

   SYSTEM ACCENT — each chemical system has its own colour
   (MeOAc purple / DME cyan / AA orange). Rather than scatter
   inline styles through the JSX, the component sets one custom
   property on a wrapper:  style={{ '--hx-sys': sysMeta.color }}
   and everything below inherits it.
   ============================================================ */

/* ─── Scope root ─────────────────────────────────────────────── */
.hx-root {
  --hx-sys: var(--color-accent);          /* overridden per system */
  --hx-sys-soft: color-mix(in srgb, var(--hx-sys) 12%, transparent);
  --hx-sys-line: color-mix(in srgb, var(--hx-sys) 34%, transparent);

  position: fixed;
  inset: 0;
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

/* color-mix is widely supported, but keep older engines legible. */
@supports not (color: color-mix(in srgb, red 50%, blue)) {
  .hx-root {
    --hx-sys-soft: var(--color-accent-dim);
    --hx-sys-line: var(--color-border-light);
  }
}

.hx-main {
  margin-left: var(--sidebar-w);
  width: calc(100% - var(--sidebar-w));
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

/* Scroll container. The 68px offset clears the fixed Navbar. */
.hx-scroll {
  flex: 1 1;
  margin-top: 68px;
  overflow-y: auto;
  padding: var(--space-lg) var(--space-lg) var(--space-xl);
  background: var(--color-panel);
}

/* LAYOUT FIX (15-Sep-2026): the page used to cap at 920–1180px and
   stack everything in one column, leaving the right half of a
   desktop viewport empty. */
.hx-container {
  max-width: 1560px;
  margin: 0 auto;
}

/* ─── Page header ────────────────────────────────────────────── */
.hx-header { margin-bottom: var(--space-md); }

.hx-header-row {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  flex-wrap: wrap;
}

.hx-title {
  font-size: var(--fs-xl);
  font-weight: 800;
  color: var(--color-text);
  font-family: var(--font-ui);
  letter-spacing: -0.2px;
}

.hx-badge {
  font-size: var(--fs-xs);
  font-weight: 700;
  color: var(--color-warning);
  background: var(--color-warning-dim);
  border: 1px solid var(--color-warning);
  border-radius: var(--radius-sm);
  padding: 2px 9px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-family: var(--font-ui);
}

.hx-intro {
  font-size: var(--fs-sm);
  color: var(--color-text-muted);
  font-family: var(--font-ui);
  margin-top: var(--space-xs);
  line-height: 1.7;
  max-width: 70ch;
}

.hx-intro strong { color: var(--color-text-mid); font-weight: 600; }

.hx-link {
  color: var(--color-accent);
  font-weight: 600;
  text-decoration: none;
}
.hx-link:hover { text-decoration: underline; }

/* ─── Reactor-type tabs ──────────────────────────────────────── */
.hx-tabs {
  display: flex;
  border-bottom: 2px solid var(--color-border);
  margin-bottom: var(--space-sm);
  overflow-x: auto;
}

.hx-tab {
  padding: 9px 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: var(--font-ui);
  cursor: pointer;
  background: transparent;
  color: var(--color-text-muted);
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  white-space: nowrap;
}
.hx-tab:hover { color: var(--color-text); background: var(--color-tab-hover); }
.hx-tab--active {
  background: var(--color-surface);
  color: var(--color-text);
  font-weight: 800;
  border-bottom-color: var(--color-tab-active);
}

/* ─── System chips ───────────────────────────────────────────── */
.hx-chips {
  display: flex;
  gap: var(--space-xs);
  margin-bottom: var(--space-sm);
  flex-wrap: wrap;
}

.hx-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 14px;
  font-size: var(--fs-xs);
  font-weight: 500;
  font-family: var(--font-ui);
  cursor: pointer;
  border-radius: 999px;
  background: transparent;
  color: var(--color-text-muted);
  border: 1px solid var(--color-border);
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}
.hx-chip:hover { border-color: var(--color-border-mid); color: var(--color-text); }
.hx-chip--active {
  background: var(--hx-sys-soft);
  color: var(--hx-sys);
  border-color: var(--hx-sys-line);
  font-weight: 700;
}

.hx-chip-tag {
  font-size: 11px;
  font-weight: 700;
  border-radius: 3px;
  padding: 0 5px;
  background: var(--hx-sys-soft);
  border: 1px solid var(--hx-sys-line);
}

/* ─── System header strip ────────────────────────────────────── */
.hx-sysbar {
  padding: var(--space-sm) var(--space-md);
  background: var(--hx-sys-soft);
  border: 1px solid var(--hx-sys-line);
  border-radius: var(--radius-sm);
  margin-bottom: var(--space-md);
}

.hx-sysbar-row {
  display: flex;
  align-items: center;
  gap: var(--space-md);
  flex-wrap: wrap;
}

.hx-sysbar-names { flex: 1 1; min-width: 260px; }

/* [MK 09-Sep] Full system name as the heading… */
.hx-sysbar-name {
  font-size: var(--fs-lg);
  font-weight: 800;
  color: var(--hx-sys);
  font-family: var(--font-ui);
  line-height: 1.3;
}

/* …with the reaction named in text underneath. */
.hx-sysbar-sub {
  font-size: var(--fs-sm);
  color: var(--color-text-muted);
  font-family: var(--font-ui);
  margin-top: 2px;
}

.hx-eq {
  background: var(--color-code-bg);
  border: 1px solid var(--hx-sys-line);
  border-radius: var(--radius-sm);
  padding: 5px 12px;
  font-size: var(--fs-sm);
  font-family: var(--font-ui);
  color: var(--hx-sys);
  font-weight: 600;
}

.hx-ref {
  font-size: var(--fs-xs);
  color: var(--color-text-dim);
  font-family: var(--font-ui);
  text-align: right;
  max-width: 34ch;
  line-height: 1.5;
}
.hx-ref-doi { color: var(--hx-sys); }

/* [MK 09-Sep] "this example will eventually be replaced… generic example" */
.hx-notice {
  font-size: var(--fs-xs);
  color: var(--color-text-dim);
  font-family: var(--font-ui);
  margin-top: var(--space-xs);
  padding-top: var(--space-xs);
  border-top: 1px solid var(--hx-sys-line);
  line-height: 1.55;
}

/* ─── Example card grid ──────────────────────────────────────────
   LAYOUT FIX: was a single vertical stack of eight tall cards, so
   reaching the last case meant scrolling past every earlier one.
   auto-fill + minmax collapses to one column unaided. */
.hx-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(430px, 1fr));
  gap: var(--space-sm);
}

.hx-card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--hx-sys-line);
  border-left: 3px solid var(--hx-sys);
  border-radius: var(--radius-sm);
  padding: 11px 14px;
  background: var(--color-card);
  cursor: pointer;
  text-align: left;
  font: inherit;
  transition: transform 0.15s, box-shadow 0.15s, border-color 0.15s;
  animation: fadeIn 0.25s ease;
}
.hx-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.14);
}

.hx-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-sm);
  margin-bottom: 5px;
}

.hx-card-name {
  display: flex;
  align-items: baseline;
  gap: 7px;
  font-size: 13.5px;
  font-weight: 700;
  color: var(--color-text);
  font-family: var(--font-ui);
  line-height: 1.35;
}

.hx-card-icon { font-size: 15px; }

.hx-card-desc {
  font-size: var(--fs-xs);
  color: var(--color-text-muted);
  font-family: var(--font-ui);
  line-height: 1.55;
}

.hx-card-detail {
  font-size: var(--fs-xs);
  color: var(--color-text-dim);
  font-family: var(--font-ui);
  line-height: 1.55;
  margin: 3px 0 7px;
}

.hx-card-rate {
  background: var(--color-code-bg);
  border: 1px solid var(--hx-sys-line);
  border-radius: var(--radius-sm);
  padding: 5px 10px;
  font-size: var(--fs-xs);
  font-family: var(--font-ui);
  color: var(--hx-sys);
  font-weight: 600;
  margin-bottom: 7px;
  line-height: 1.6;
}

.hx-card-rate-label {
  color: var(--color-text-dim);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  margin-right: 8px;
}

.hx-card-open {
  font-size: var(--fs-xs);
  color: var(--hx-sys);
  font-family: var(--font-ui);
  margin-top: 7px;
  font-weight: 600;
}

/* ─── Tags / pills ───────────────────────────────────────────── */
.hx-taglist {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  margin-top: auto;
}

.hx-tag {
  font-size: 11px;
  font-family: var(--font-ui);
  color: var(--color-text-dim);
  background: var(--color-panel);
  border: 1px solid var(--color-border-light);
  border-radius: 3px;
  padding: 2px 7px;
  white-space: nowrap;
}

.hx-tag--scope {
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--hx-sys);
  background: var(--hx-sys-soft);
  border-color: var(--hx-sys-line);
}

/* Provenance badges on datasets — "published" vs "model-generated".
   These carry real meaning, so they are visually distinct, not decoration. */
.hx-tag--published {
  color: var(--color-success);
  background: var(--color-success-dim);
  border-color: var(--color-success);
  font-weight: 700;
}
.hx-tag--derived {
  color: var(--color-cyan);
  background: var(--color-cyan-dim);
  border-color: var(--color-cyan);
  font-weight: 700;
}

/* ─── Workspace header ───────────────────────────────────────── */
.hx-wshead {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  margin-bottom: var(--space-sm);
  flex-wrap: wrap;
}

.hx-eyebrow {
  font-size: var(--fs-xs);
  font-weight: 700;
  color: var(--hx-sys);
  text-transform: uppercase;
  letter-spacing: 0.07em;
  font-family: var(--font-ui);
}

.hx-eyebrow--spaced { margin: 8px 0 4px; }

.hx-wstitle {
  font-size: var(--fs-lg);
  font-weight: 800;
  color: var(--color-text);
  font-family: var(--font-ui);
}

/* ─── Step navigation ────────────────────────────────────────── */
.hx-steps {
  display: flex;
  gap: var(--space-xs);
  margin-bottom: var(--space-md);
  flex-wrap: wrap;
}

.hx-step {
  padding: 6px 14px;
  font-size: var(--fs-xs);
  font-weight: 700;
  font-family: var(--font-ui);
  border-radius: var(--radius-sm);
  border: 1px solid var(--color-border);
  background: transparent;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  white-space: nowrap;
}
.hx-step:hover:not(:disabled) { color: var(--color-text); }
.hx-step--active {
  border-color: var(--hx-sys);
  background: var(--hx-sys-soft);
  color: var(--hx-sys);
}
.hx-step:disabled { opacity: 0.45; cursor: default; color: var(--color-text-dim); }

/* ─── Two-column workspace grid ──────────────────────────────── */
.hx-2col {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: var(--space-md);
  align-items: start;
}

.hx-3col {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--space-md);
  align-items: start;
}

.hx-stack {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}

/* ─── Cards ──────────────────────────────────────────────────── */
.hx-panel {
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  padding: var(--space-sm) var(--space-md);
  background: var(--color-card);
  animation: fadeIn 0.2s ease;
}

.hx-panel-title {
  font-size: 11px;
  font-weight: 700;
  color: var(--color-text-dim);
  text-transform: uppercase;
  letter-spacing: 0.07em;
  font-family: var(--font-ui);
  margin-bottom: 7px;
}

.hx-panel-hint {
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
  color: var(--color-text-dim);
}

.hx-body {
  font-size: var(--fs-sm);
  color: var(--color-text-muted);
  font-family: var(--font-ui);
  line-height: 1.65;
}

.hx-body--dim { color: var(--color-text-dim); font-size: var(--fs-xs); }

.hx-mono {
  font-size: var(--fs-xs);
  font-family: var(--font-mono);
  color: var(--color-text-muted);
  line-height: 1.7;
}

/* ─── Reaction list ──────────────────────────────────────────── */
.hx-rxn {
  background: var(--color-code-bg);
  border: 1px solid var(--hx-sys-line);
  border-radius: var(--radius-sm);
  padding: 5px 10px;
  font-size: var(--fs-sm);
  font-family: var(--font-ui);
  color: var(--hx-sys);
  font-weight: 600;
  margin-bottom: 5px;
}
.hx-rxn-idx { color: var(--color-text-dim); margin-right: 8px; }

.hx-compounds { display: flex; gap: 7px; flex-wrap: wrap; }

.hx-compound {
  font-size: var(--fs-xs);
  font-family: var(--font-ui);
  color: var(--color-text);
  background: var(--color-panel);
  border: 1px solid var(--color-border-light);
  border-radius: var(--radius-sm);
  padding: 4px 10px;
}

/* ─── Lock banner ────────────────────────────────────────────── */
.hx-lock {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-sm);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  padding: 8px 14px;
  background: var(--color-code-bg);
  margin-bottom: var(--space-md);
  flex-wrap: wrap;
}
.hx-lock--open {
  border-color: var(--hx-sys);
  background: var(--hx-sys-soft);
}

.hx-lock-text {
  font-size: var(--fs-xs);
  font-family: var(--font-ui);
  color: var(--color-text-dim);
  font-weight: 600;
}
.hx-lock--open .hx-lock-text { color: var(--hx-sys); }

/* ─── Toggles / fields ───────────────────────────────────────── */
.hx-field { margin-bottom: var(--space-xs); flex: 1 1; min-width: 0; }

.hx-field-label {
  font-size: 10px;
  font-weight: 700;
  color: var(--color-text-dim);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-family: var(--font-ui);
  margin-bottom: 4px;
}

.hx-toggle { display: flex; gap: 4px; }

.hx-toggle-btn {
  flex: 1 1;
  padding: 6px 0;
  font-size: var(--fs-xs);
  font-family: var(--font-ui);
  font-weight: 600;
  border-radius: var(--radius-sm);
  cursor: pointer;
  border: 1px solid var(--color-border);
  background: transparent;
  color: var(--color-text-muted);
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}
.hx-toggle-btn:hover:not(:disabled) { border-color: var(--color-border-mid); }
.hx-toggle-btn--on {
  background: var(--color-toggle);
  border-color: var(--color-toggle);
  color: #fff;
}
.hx-toggle-btn:disabled { cursor: default; }
.hx-toggle-btn:disabled:not(.hx-toggle-btn--on) { opacity: 0.5; }

.hx-input-wrap {
  display: flex;
  align-items: center;
  border: 1px solid var(--color-input-border);
  border-radius: var(--radius-sm);
  background: var(--color-input-bg);
  transition: border-color 0.15s, box-shadow 0.15s;
}
.hx-input-wrap:focus-within {
  border-color: var(--color-accent);
  box-shadow: 0 0 0 3px var(--color-accent-dim);
}
.hx-input-wrap--disabled { background: var(--color-code-bg); opacity: 0.7; }

.hx-input {
  flex: 1 1;
  min-width: 0;
  background: transparent;
  border: none;
  color: var(--color-text);
  font-family: var(--font-ui);
  font-size: var(--fs-xs);
  padding: 6px 8px;
  outline: none;
}
.hx-input:disabled { cursor: default; }

.hx-input-unit {
  font-size: 11px;
  color: var(--color-text-dim);
  font-family: var(--font-ui);
  padding: 0 8px;
}

.hx-select {
  appearance: none;
  width: 100%;
  padding: 6px 28px 6px 8px;
  background: var(--color-input-bg) url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right 9px center;
  border: 1px solid var(--color-input-border);
  border-radius: var(--radius-sm);
  font-size: var(--fs-xs);
  font-family: var(--font-ui);
  color: var(--color-text);
  cursor: pointer;
  outline: none;
}
.hx-select:focus {
  border-color: var(--color-accent);
  box-shadow: 0 0 0 3px var(--color-accent-dim);
}

.hx-row { display: flex; gap: var(--space-xs); }

/* ─── Buttons ────────────────────────────────────────────────── */
.hx-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 9px 16px;
  border-radius: var(--radius-sm);
  border: 1px solid transparent;
  cursor: pointer;
  font-size: var(--fs-sm);
  font-weight: 600;
  font-family: var(--font-ui);
  transition: background 0.15s, color 0.15s, border-color 0.15s, opacity 0.15s;
  white-space: nowrap;
}

.hx-btn--ghost {
  background: transparent;
  border-color: var(--color-border);
  color: var(--color-text-muted);
  font-size: var(--fs-xs);
}
.hx-btn--ghost:hover { color: var(--color-text); border-color: var(--color-border-mid); }

.hx-btn--primary {
  background: var(--hx-sys);
  color: #fff;
  font-weight: 700;
}
.hx-btn--primary:hover { filter: brightness(1.08); }

.hx-btn--run { flex: 1 1; padding: 9px 0; }
.hx-btn:disabled { opacity: 0.65; cursor: not-allowed; }

.hx-actions {
  display: flex;
  gap: var(--space-xs);
  margin-top: var(--space-md);
  flex-wrap: wrap;
}
.hx-actions--end { justify-content: flex-end; }

/* ─── Dataset switcher ───────────────────────────────────────── */
.hx-dstabs {
  display: flex;
  gap: var(--space-xs);
  margin-bottom: var(--space-xs);
  flex-wrap: wrap;
}

.hx-dstab {
  padding: 4px 11px;
  font-size: var(--fs-xs);
  font-weight: 700;
  font-family: var(--font-ui);
  border-radius: var(--radius-sm);
  cursor: pointer;
  border: 1px solid var(--color-border);
  background: transparent;
  color: var(--color-text-muted);
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}
.hx-dstab--active {
  border-color: var(--hx-sys);
  background: var(--hx-sys-soft);
  color: var(--hx-sys);
}

/* ─── Data tables ────────────────────────────────────────────────
   Capped height + sticky header: a 20-row run can no longer push
   the rest of the step below the fold. */
.hx-tablewrap { overflow: auto; max-height: 340px; }
.hx-tablewrap--short { max-height: 260px; }
.hx-tablewrap--tall  { max-height: 440px; }

.hx-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--fs-xs);
  font-family: var(--font-ui);
}

.hx-table th {
  text-align: left;
  font-weight: 600;
  color: var(--color-text-dim);
  padding: 4px;
  white-space: nowrap;
  position: sticky;
  top: 0;
  background: var(--color-card);
  box-shadow: inset 0 -1px 0 var(--color-border);
  z-index: 1;
}

.hx-table td {
  padding: 4px;
  color: var(--color-text-muted);
  white-space: nowrap;
  border-top: 1px solid var(--color-border-light);
}

.hx-table tbody tr:hover td { background: var(--hx-sys-soft); }
.hx-table .hx-td-check { width: 22px; }
.hx-table .hx-td-name  { color: var(--color-text); }
.hx-table .hx-th-center,
.hx-table .hx-td-center { text-align: center; }

/* Visually hidden but announced — used for the unlabelled checkbox column
   header, which otherwise reads as an empty cell to a screen reader. */
.hx-sr {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

/* ─── Chart ──────────────────────────────────────────────────── */
.hx-chart { width: 100%; display: block; }
.hx-chart-grid      { stroke: var(--color-border); stroke-width: 1; }
.hx-chart-grid--v   { stroke-width: 0.5; opacity: 0.5; }
.hx-chart-axis      { stroke: var(--color-text-dim); stroke-width: 1.2; }
.hx-chart-tick      { fill: var(--color-text-dim); font-size: 9px; }
.hx-chart-axislabel { fill: var(--color-text-muted); font-size: 10px; }
.hx-chart-legend    { fill: var(--color-text-muted); font-size: 9px; }
.hx-chart-line      { fill: none; stroke-width: 1.5; opacity: 0.75; }

.hx-plot {
  width: 100%;
  border-radius: var(--radius-sm);
  border: 1px solid var(--color-border);
  display: block;
}

/* ─── Status / progress / log ────────────────────────────────── */
.hx-progress {
  margin-top: var(--space-xs);
  height: 4px;
  background: var(--color-border);
  border-radius: 2px;
  overflow: hidden;
}
.hx-progress-bar {
  height: 100%;
  background: var(--hx-sys);
  transition: width 0.4s ease;
}

.hx-log {
  font-size: 11px;
  font-family: var(--font-mono);
  color: var(--color-text-muted);
  line-height: 1.6;
  max-height: 300px;
  overflow-y: auto;
  white-space: pre-wrap;
}

.hx-empty {
  color: var(--color-text-dim);
  font-family: var(--font-ui);
  font-size: var(--fs-xs);
  padding: var(--space-lg) 0;
  text-align: center;
}

.hx-error {
  color: var(--color-error);
  font-family: var(--font-ui);
  font-size: var(--fs-xs);
  line-height: 1.65;
  padding: var(--space-sm) 0;
}
.hx-ok { color: var(--color-success); }

/* Callout used when live edits diverge from the reference setup. */
.hx-callout {
  font-size: var(--fs-xs);
  color: var(--hx-sys);
  font-family: var(--font-ui);
  background: var(--hx-sys-soft);
  border: 1px solid var(--hx-sys-line);
  border-radius: var(--radius-sm);
  padding: 6px 9px;
  margin-bottom: var(--space-xs);
  line-height: 1.55;
}

/* Provenance note under a dataset table. */
.hx-provenance {
  font-size: var(--fs-xs);
  color: var(--color-text-dim);
  font-family: var(--font-ui);
  line-height: 1.55;
  margin-bottom: var(--space-xs);
}
.hx-provenance cite { font-style: normal; color: var(--color-text-muted); }

/* ─── Responsive ─────────────────────────────────────────────────
   Breakpoints mirror DataFittingPage.css (860 / 640 / 480). */
@media (max-width: 1100px) {
  .hx-cards { grid-template-columns: 1fr; }
}

@media (max-width: 860px) {
  .hx-main {
    margin-left: 0;
    width: 100%;
  }
  .hx-scroll { padding: var(--space-md); }
  .hx-2col,
  .hx-3col { grid-template-columns: 1fr; }
  .hx-ref {
    text-align: left;
    max-width: none;
  }
}

@media (max-width: 640px) {
  .hx-title { font-size: var(--fs-lg); }
  .hx-row { flex-direction: column; gap: 0; }
  .hx-tablewrap,
  .hx-tablewrap--short,
  .hx-tablewrap--tall { max-height: 300px; }
}

@media (max-width: 480px) {
  .hx-actions { flex-direction: column; align-items: stretch; }
  .hx-btn { width: 100%; }
  .hx-step { flex: 1 1 45%; }
}

/* ─── Reduced motion ─────────────────────────────────────────── */
@media (prefers-reduced-motion: reduce) {
  .hx-card,
  .hx-panel { animation: none; }
  .hx-card:hover { transform: none; }
  .hx-progress-bar { transition: none; }
}

/* ─── Print ──────────────────────────────────────────────────── */
@media print {
  .hx-root { position: static; height: auto; }
  .hx-main { margin-left: 0; width: 100%; }
  .hx-scroll { overflow: visible; margin-top: 0; }
  .hx-tablewrap,
  .hx-tablewrap--short,
  .hx-tablewrap--tall { max-height: none; overflow: visible; }
  .hx-steps, .hx-actions, .hx-tabs { display: none; }
}

/* Iglesia 2008 review-example indicators. This is deliberately an amber/
   neutral warning rather than a red error: the example is runnable for
   platform validation but is not yet approved as a paper-faithful model. */
.hx-tag--warning {
  color: #B7770D;
  background: rgba(243,156,18,0.10);
  border-color: rgba(243,156,18,0.28);
}

.hx-review-banner {
  margin-top: 7px;
  padding: 8px 10px;
  border: 1px solid rgba(243,156,18,0.28);
  border-radius: var(--radius-sm);
  background: rgba(243,156,18,0.08);
  color: #B7770D;
  font-size: var(--fs-xs);
  font-family: var(--font-ui);
  line-height: 1.5;
  max-width: 90ch;
}
`, "",{"version":3,"sources":["webpack://./src/styles/HelpExamples.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;iEAqBiE;;AAEjE,mEAAmE;AACnE;EACE,6BAA6B,WAAW,0BAA0B;EAClE,iEAAiE;EACjE,iEAAiE;;EAEjE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE;IACE,sCAAsC;IACtC,wCAAwC;EAC1C;AACF;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,wDAAwD;EACxD,8BAA8B;AAChC;;AAEA;;4BAE4B;AAC5B;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,mEAAmE;AACnE,aAAa,8BAA8B,EAAE;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;EACxB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,oCAAoC;EACpC,sCAAsC;EACtC,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mBAAmB,4BAA4B,EAAE,gBAAgB,EAAE;;AAEnE;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;AACA,iBAAiB,0BAA0B,EAAE;;AAE7C,mEAAmE;AACnE;EACE,aAAa;EACb,4CAA4C;EAC5C,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,6DAA6D;EAC7D,mBAAmB;AACrB;AACA,gBAAgB,wBAAwB,EAAE,kCAAkC,EAAE;AAC9E;EACE,gCAAgC;EAChC,wBAAwB;EACxB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,8BAA8B;EAC9B,qCAAqC;EACrC,6DAA6D;AAC/D;AACA,iBAAiB,qCAAqC,EAAE,wBAAwB,EAAE;AAClF;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA,mEAAmE;AACnE;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,mBAAmB,SAAO,EAAE,gBAAgB,EAAE;;AAE9C,iDAAiD;AACjD;EACE,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,+BAA+B;EAC/B,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA,cAAc,oBAAoB,EAAE;;AAEpC,4EAA4E;AAC5E;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;;;wDAGwD;AACxD;EACE,aAAa;EACb,4DAA4D;EAC5D,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,iEAAiE;EACjE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,gBAAgB,eAAe,EAAE;;AAEjC;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,+BAA+B;EAC/B,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;6EAC6E;AAC7E;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,sBAAsB,iBAAiB,EAAE;;AAEzC;EACE,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,+BAA+B;EAC/B,qCAAqC;EACrC,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;AACrB;AACA,gCAAgC,wBAAwB,EAAE;AAC1D;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,oBAAoB;AACtB;AACA,oBAAoB,aAAa,EAAE,eAAe,EAAE,4BAA4B,EAAE;;AAElF,mEAAmE;AACnE;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,mEAAmE;AACnE;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,wCAAwC;EACxC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,gBAAgB,4BAA4B,EAAE,uBAAuB,EAAE;;AAEvE;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,gCAAgC;EAChC,oCAAoC;EACpC,+BAA+B;EAC/B,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,cAAc,4BAA4B,EAAE,iBAAiB,EAAE;;AAE/D,gBAAgB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAE1D;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,2CAA2C;EAC3C,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,qCAAqC;EACrC,+BAA+B;EAC/B,iBAAiB;EACjB,gCAAgC;EAChC,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;AAClB;AACA,+BAA+B,oBAAoB,EAAE;;AAErD,mEAAmE;AACnE,YAAY,8BAA8B,EAAE,SAAO,EAAE,YAAY,EAAE;;AAEnE;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,aAAa,aAAa,EAAE,QAAQ,EAAE;;AAEtC;EACE,SAAO;EACP,cAAc;EACd,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,qCAAqC;EACrC,uBAAuB;EACvB,8BAA8B;EAC9B,6DAA6D;AAC/D;AACA,sCAAsC,qCAAqC,EAAE;AAC7E;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,WAAW;AACb;AACA,0BAA0B,eAAe,EAAE;AAC3C,kDAAkD,YAAY,EAAE;;AAEhE;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,+BAA+B;EAC/B,iCAAiC;EACjC,gDAAgD;AAClD;AACA;EACE,iCAAiC;EACjC,6CAA6C;AAC/C;AACA,2BAA2B,gCAAgC,EAAE,YAAY,EAAE;;AAE3E;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;AACA,qBAAqB,eAAe,EAAE;;AAEtC;EACE,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,oGAAmT;EACnT,2CAA2C;EAC3C,+BAA+B;EAC/B,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,eAAe;EACf,aAAa;AACf;AACA;EACE,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA,UAAU,aAAa,EAAE,oBAAoB,EAAE;;AAE/C,mEAAmE;AACnE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,4EAA4E;EAC5E,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,8BAA8B;EAC9B,uBAAuB;AACzB;AACA,uBAAuB,wBAAwB,EAAE,qCAAqC,EAAE;;AAExF;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;AACA,yBAAyB,wBAAwB,EAAE;;AAEnD,eAAe,SAAO,EAAE,cAAc,EAAE;AACxC,mBAAmB,aAAa,EAAE,mBAAmB,EAAE;;AAEvD;EACE,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,eAAe;AACjB;AACA,mBAAmB,yBAAyB,EAAE;;AAE9C,mEAAmE;AACnE;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,+BAA+B;EAC/B,eAAe;EACf,qCAAqC;EACrC,uBAAuB;EACvB,8BAA8B;EAC9B,6DAA6D;AAC/D;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;;yCAEyC;AACzC,gBAAgB,cAAc,EAAE,iBAAiB,EAAE;AACnD,uBAAuB,iBAAiB,EAAE;AAC1C,uBAAuB,iBAAiB,EAAE;;AAE1C;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,6BAA6B;EAC7B,8CAA8C;EAC9C,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA,8BAA8B,8BAA8B,EAAE;AAC9D,yBAAyB,WAAW,EAAE;AACtC,yBAAyB,wBAAwB,EAAE;AACnD;0BAC0B,kBAAkB,EAAE;;AAE9C;uEACuE;AACvE;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;AACX;;AAEA,mEAAmE;AACnE,YAAY,WAAW,EAAE,cAAc,EAAE;AACzC,sBAAsB,2BAA2B,EAAE,eAAe,EAAE;AACpE,sBAAsB,iBAAiB,EAAE,YAAY,EAAE;AACvD,sBAAsB,6BAA6B,EAAE,iBAAiB,EAAE;AACxE,sBAAsB,2BAA2B,EAAE,cAAc,EAAE;AACnE,sBAAsB,6BAA6B,EAAE,eAAe,EAAE;AACtE,sBAAsB,6BAA6B,EAAE,cAAc,EAAE;AACrE,sBAAsB,UAAU,EAAE,iBAAiB,EAAE,aAAa,EAAE;;AAEpE;EACE,WAAW;EACX,+BAA+B;EAC/B,qCAAqC;EACrC,cAAc;AAChB;;AAEA,mEAAmE;AACnE;EACE,2BAA2B;EAC3B,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;AAC5B;AACA,SAAS,2BAA2B,EAAE;;AAEtC,mEAAmE;AACnE;EACE,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;EAC/B,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,iBAAiB;EACjB,8BAA8B;AAChC;AACA,sBAAsB,kBAAkB,EAAE,8BAA8B,EAAE;;AAE1E;8DAC8D;AAC9D;EACE,YAAY,0BAA0B,EAAE;AAC1C;;AAEA;EACE;IACE,cAAc;IACd,WAAW;EACb;EACA,aAAa,wBAAwB,EAAE;EACvC;aACW,0BAA0B,EAAE;EACvC;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,YAAY,uBAAuB,EAAE;EACrC,UAAU,sBAAsB,EAAE,MAAM,EAAE;EAC1C;;wBAEsB,iBAAiB,EAAE;AAC3C;;AAEA;EACE,cAAc,sBAAsB,EAAE,oBAAoB,EAAE;EAC5D,UAAU,WAAW,EAAE;EACvB,WAAW,aAAa,EAAE;AAC5B;;AAEA,mEAAmE;AACnE;EACE;cACY,eAAe,EAAE;EAC7B,iBAAiB,eAAe,EAAE;EAClC,mBAAmB,gBAAgB,EAAE;AACvC;;AAEA,mEAAmE;AACnE;EACE,WAAW,gBAAgB,EAAE,YAAY,EAAE;EAC3C,WAAW,cAAc,EAAE,WAAW,EAAE;EACxC,aAAa,iBAAiB,EAAE,aAAa,EAAE;EAC/C;;wBAEsB,gBAAgB,EAAE,iBAAiB,EAAE;EAC3D,mCAAmC,aAAa,EAAE;AACpD;;AAEA;;2EAE2E;AAC3E;EACE,cAAc;EACd,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uCAAuC;EACvC,+BAA+B;EAC/B,iCAAiC;EACjC,cAAc;EACd,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["/* ============================================================\n   HelpExamples.css  —  KinetiQ  ·  Help → Examples\n   ------------------------------------------------------------\n   Companion stylesheet to DataFittingPage.css. Prefix is `hx-`\n   (DataFittingPage owns `df-`), so the two can be loaded\n   together on the same document with no collisions.\n\n   DEPENDENCY — this file deliberately defines NO design tokens.\n   Every --color-*, --space-*, --radius-*, --fs-*, --font-* and\n   --sidebar-w it consumes is declared in DataFittingPage.css's\n   :root / [data-theme] blocks. That is what makes this page\n   re-theme automatically when data-theme flips on <html>.\n   Import DataFittingPage.css first, or hoist those blocks into\n   a shared tokens.css. Fallbacks are supplied on the few\n   tokens not present in every older build.\n\n   SYSTEM ACCENT — each chemical system has its own colour\n   (MeOAc purple / DME cyan / AA orange). Rather than scatter\n   inline styles through the JSX, the component sets one custom\n   property on a wrapper:  style={{ '--hx-sys': sysMeta.color }}\n   and everything below inherits it.\n   ============================================================ */\n\n/* ─── Scope root ─────────────────────────────────────────────── */\n.hx-root {\n  --hx-sys: var(--color-accent);          /* overridden per system */\n  --hx-sys-soft: color-mix(in srgb, var(--hx-sys) 12%, transparent);\n  --hx-sys-line: color-mix(in srgb, var(--hx-sys) 34%, transparent);\n\n  position: fixed;\n  inset: 0;\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n}\n\n/* color-mix is widely supported, but keep older engines legible. */\n@supports not (color: color-mix(in srgb, red 50%, blue)) {\n  .hx-root {\n    --hx-sys-soft: var(--color-accent-dim);\n    --hx-sys-line: var(--color-border-light);\n  }\n}\n\n.hx-main {\n  margin-left: var(--sidebar-w);\n  width: calc(100% - var(--sidebar-w));\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n}\n\n/* Scroll container. The 68px offset clears the fixed Navbar. */\n.hx-scroll {\n  flex: 1;\n  margin-top: 68px;\n  overflow-y: auto;\n  padding: var(--space-lg) var(--space-lg) var(--space-xl);\n  background: var(--color-panel);\n}\n\n/* LAYOUT FIX (15-Sep-2026): the page used to cap at 920–1180px and\n   stack everything in one column, leaving the right half of a\n   desktop viewport empty. */\n.hx-container {\n  max-width: 1560px;\n  margin: 0 auto;\n}\n\n/* ─── Page header ────────────────────────────────────────────── */\n.hx-header { margin-bottom: var(--space-md); }\n\n.hx-header-row {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  flex-wrap: wrap;\n}\n\n.hx-title {\n  font-size: var(--fs-xl);\n  font-weight: 800;\n  color: var(--color-text);\n  font-family: var(--font-ui);\n  letter-spacing: -0.2px;\n}\n\n.hx-badge {\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  color: var(--color-warning);\n  background: var(--color-warning-dim);\n  border: 1px solid var(--color-warning);\n  border-radius: var(--radius-sm);\n  padding: 2px 9px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  font-family: var(--font-ui);\n}\n\n.hx-intro {\n  font-size: var(--fs-sm);\n  color: var(--color-text-muted);\n  font-family: var(--font-ui);\n  margin-top: var(--space-xs);\n  line-height: 1.7;\n  max-width: 70ch;\n}\n\n.hx-intro strong { color: var(--color-text-mid); font-weight: 600; }\n\n.hx-link {\n  color: var(--color-accent);\n  font-weight: 600;\n  text-decoration: none;\n}\n.hx-link:hover { text-decoration: underline; }\n\n/* ─── Reactor-type tabs ──────────────────────────────────────── */\n.hx-tabs {\n  display: flex;\n  border-bottom: 2px solid var(--color-border);\n  margin-bottom: var(--space-sm);\n  overflow-x: auto;\n}\n\n.hx-tab {\n  padding: 9px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: var(--font-ui);\n  cursor: pointer;\n  background: transparent;\n  color: var(--color-text-muted);\n  border: none;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n  white-space: nowrap;\n}\n.hx-tab:hover { color: var(--color-text); background: var(--color-tab-hover); }\n.hx-tab--active {\n  background: var(--color-surface);\n  color: var(--color-text);\n  font-weight: 800;\n  border-bottom-color: var(--color-tab-active);\n}\n\n/* ─── System chips ───────────────────────────────────────────── */\n.hx-chips {\n  display: flex;\n  gap: var(--space-xs);\n  margin-bottom: var(--space-sm);\n  flex-wrap: wrap;\n}\n\n.hx-chip {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 14px;\n  font-size: var(--fs-xs);\n  font-weight: 500;\n  font-family: var(--font-ui);\n  cursor: pointer;\n  border-radius: 999px;\n  background: transparent;\n  color: var(--color-text-muted);\n  border: 1px solid var(--color-border);\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n}\n.hx-chip:hover { border-color: var(--color-border-mid); color: var(--color-text); }\n.hx-chip--active {\n  background: var(--hx-sys-soft);\n  color: var(--hx-sys);\n  border-color: var(--hx-sys-line);\n  font-weight: 700;\n}\n\n.hx-chip-tag {\n  font-size: 11px;\n  font-weight: 700;\n  border-radius: 3px;\n  padding: 0 5px;\n  background: var(--hx-sys-soft);\n  border: 1px solid var(--hx-sys-line);\n}\n\n/* ─── System header strip ────────────────────────────────────── */\n.hx-sysbar {\n  padding: var(--space-sm) var(--space-md);\n  background: var(--hx-sys-soft);\n  border: 1px solid var(--hx-sys-line);\n  border-radius: var(--radius-sm);\n  margin-bottom: var(--space-md);\n}\n\n.hx-sysbar-row {\n  display: flex;\n  align-items: center;\n  gap: var(--space-md);\n  flex-wrap: wrap;\n}\n\n.hx-sysbar-names { flex: 1; min-width: 260px; }\n\n/* [MK 09-Sep] Full system name as the heading… */\n.hx-sysbar-name {\n  font-size: var(--fs-lg);\n  font-weight: 800;\n  color: var(--hx-sys);\n  font-family: var(--font-ui);\n  line-height: 1.3;\n}\n\n/* …with the reaction named in text underneath. */\n.hx-sysbar-sub {\n  font-size: var(--fs-sm);\n  color: var(--color-text-muted);\n  font-family: var(--font-ui);\n  margin-top: 2px;\n}\n\n.hx-eq {\n  background: var(--color-code-bg);\n  border: 1px solid var(--hx-sys-line);\n  border-radius: var(--radius-sm);\n  padding: 5px 12px;\n  font-size: var(--fs-sm);\n  font-family: var(--font-ui);\n  color: var(--hx-sys);\n  font-weight: 600;\n}\n\n.hx-ref {\n  font-size: var(--fs-xs);\n  color: var(--color-text-dim);\n  font-family: var(--font-ui);\n  text-align: right;\n  max-width: 34ch;\n  line-height: 1.5;\n}\n.hx-ref-doi { color: var(--hx-sys); }\n\n/* [MK 09-Sep] \"this example will eventually be replaced… generic example\" */\n.hx-notice {\n  font-size: var(--fs-xs);\n  color: var(--color-text-dim);\n  font-family: var(--font-ui);\n  margin-top: var(--space-xs);\n  padding-top: var(--space-xs);\n  border-top: 1px solid var(--hx-sys-line);\n  line-height: 1.55;\n}\n\n/* ─── Example card grid ──────────────────────────────────────────\n   LAYOUT FIX: was a single vertical stack of eight tall cards, so\n   reaching the last case meant scrolling past every earlier one.\n   auto-fill + minmax collapses to one column unaided. */\n.hx-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(430px, 1fr));\n  gap: var(--space-sm);\n}\n\n.hx-card {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--hx-sys-line);\n  border-left: 3px solid var(--hx-sys);\n  border-radius: var(--radius-sm);\n  padding: 11px 14px;\n  background: var(--color-card);\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n  transition: transform 0.15s, box-shadow 0.15s, border-color 0.15s;\n  animation: fadeIn 0.25s ease;\n}\n.hx-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.14);\n}\n\n.hx-card-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--space-sm);\n  margin-bottom: 5px;\n}\n\n.hx-card-name {\n  display: flex;\n  align-items: baseline;\n  gap: 7px;\n  font-size: 13.5px;\n  font-weight: 700;\n  color: var(--color-text);\n  font-family: var(--font-ui);\n  line-height: 1.35;\n}\n\n.hx-card-icon { font-size: 15px; }\n\n.hx-card-desc {\n  font-size: var(--fs-xs);\n  color: var(--color-text-muted);\n  font-family: var(--font-ui);\n  line-height: 1.55;\n}\n\n.hx-card-detail {\n  font-size: var(--fs-xs);\n  color: var(--color-text-dim);\n  font-family: var(--font-ui);\n  line-height: 1.55;\n  margin: 3px 0 7px;\n}\n\n.hx-card-rate {\n  background: var(--color-code-bg);\n  border: 1px solid var(--hx-sys-line);\n  border-radius: var(--radius-sm);\n  padding: 5px 10px;\n  font-size: var(--fs-xs);\n  font-family: var(--font-ui);\n  color: var(--hx-sys);\n  font-weight: 600;\n  margin-bottom: 7px;\n  line-height: 1.6;\n}\n\n.hx-card-rate-label {\n  color: var(--color-text-dim);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  margin-right: 8px;\n}\n\n.hx-card-open {\n  font-size: var(--fs-xs);\n  color: var(--hx-sys);\n  font-family: var(--font-ui);\n  margin-top: 7px;\n  font-weight: 600;\n}\n\n/* ─── Tags / pills ───────────────────────────────────────────── */\n.hx-taglist {\n  display: flex;\n  gap: 5px;\n  flex-wrap: wrap;\n  margin-top: auto;\n}\n\n.hx-tag {\n  font-size: 11px;\n  font-family: var(--font-ui);\n  color: var(--color-text-dim);\n  background: var(--color-panel);\n  border: 1px solid var(--color-border-light);\n  border-radius: 3px;\n  padding: 2px 7px;\n  white-space: nowrap;\n}\n\n.hx-tag--scope {\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--hx-sys);\n  background: var(--hx-sys-soft);\n  border-color: var(--hx-sys-line);\n}\n\n/* Provenance badges on datasets — \"published\" vs \"model-generated\".\n   These carry real meaning, so they are visually distinct, not decoration. */\n.hx-tag--published {\n  color: var(--color-success);\n  background: var(--color-success-dim);\n  border-color: var(--color-success);\n  font-weight: 700;\n}\n.hx-tag--derived {\n  color: var(--color-cyan);\n  background: var(--color-cyan-dim);\n  border-color: var(--color-cyan);\n  font-weight: 700;\n}\n\n/* ─── Workspace header ───────────────────────────────────────── */\n.hx-wshead {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  margin-bottom: var(--space-sm);\n  flex-wrap: wrap;\n}\n\n.hx-eyebrow {\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  color: var(--hx-sys);\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  font-family: var(--font-ui);\n}\n\n.hx-eyebrow--spaced { margin: 8px 0 4px; }\n\n.hx-wstitle {\n  font-size: var(--fs-lg);\n  font-weight: 800;\n  color: var(--color-text);\n  font-family: var(--font-ui);\n}\n\n/* ─── Step navigation ────────────────────────────────────────── */\n.hx-steps {\n  display: flex;\n  gap: var(--space-xs);\n  margin-bottom: var(--space-md);\n  flex-wrap: wrap;\n}\n\n.hx-step {\n  padding: 6px 14px;\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  font-family: var(--font-ui);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--color-border);\n  background: transparent;\n  color: var(--color-text-muted);\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n  white-space: nowrap;\n}\n.hx-step:hover:not(:disabled) { color: var(--color-text); }\n.hx-step--active {\n  border-color: var(--hx-sys);\n  background: var(--hx-sys-soft);\n  color: var(--hx-sys);\n}\n.hx-step:disabled { opacity: 0.45; cursor: default; color: var(--color-text-dim); }\n\n/* ─── Two-column workspace grid ──────────────────────────────── */\n.hx-2col {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: var(--space-md);\n  align-items: start;\n}\n\n.hx-3col {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: var(--space-md);\n  align-items: start;\n}\n\n.hx-stack {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n}\n\n/* ─── Cards ──────────────────────────────────────────────────── */\n.hx-panel {\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-sm);\n  padding: var(--space-sm) var(--space-md);\n  background: var(--color-card);\n  animation: fadeIn 0.2s ease;\n}\n\n.hx-panel-title {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--color-text-dim);\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  font-family: var(--font-ui);\n  margin-bottom: 7px;\n}\n\n.hx-panel-hint {\n  font-weight: 500;\n  text-transform: none;\n  letter-spacing: 0;\n  color: var(--color-text-dim);\n}\n\n.hx-body {\n  font-size: var(--fs-sm);\n  color: var(--color-text-muted);\n  font-family: var(--font-ui);\n  line-height: 1.65;\n}\n\n.hx-body--dim { color: var(--color-text-dim); font-size: var(--fs-xs); }\n\n.hx-mono {\n  font-size: var(--fs-xs);\n  font-family: var(--font-mono);\n  color: var(--color-text-muted);\n  line-height: 1.7;\n}\n\n/* ─── Reaction list ──────────────────────────────────────────── */\n.hx-rxn {\n  background: var(--color-code-bg);\n  border: 1px solid var(--hx-sys-line);\n  border-radius: var(--radius-sm);\n  padding: 5px 10px;\n  font-size: var(--fs-sm);\n  font-family: var(--font-ui);\n  color: var(--hx-sys);\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n.hx-rxn-idx { color: var(--color-text-dim); margin-right: 8px; }\n\n.hx-compounds { display: flex; gap: 7px; flex-wrap: wrap; }\n\n.hx-compound {\n  font-size: var(--fs-xs);\n  font-family: var(--font-ui);\n  color: var(--color-text);\n  background: var(--color-panel);\n  border: 1px solid var(--color-border-light);\n  border-radius: var(--radius-sm);\n  padding: 4px 10px;\n}\n\n/* ─── Lock banner ────────────────────────────────────────────── */\n.hx-lock {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-sm);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-sm);\n  padding: 8px 14px;\n  background: var(--color-code-bg);\n  margin-bottom: var(--space-md);\n  flex-wrap: wrap;\n}\n.hx-lock--open {\n  border-color: var(--hx-sys);\n  background: var(--hx-sys-soft);\n}\n\n.hx-lock-text {\n  font-size: var(--fs-xs);\n  font-family: var(--font-ui);\n  color: var(--color-text-dim);\n  font-weight: 600;\n}\n.hx-lock--open .hx-lock-text { color: var(--hx-sys); }\n\n/* ─── Toggles / fields ───────────────────────────────────────── */\n.hx-field { margin-bottom: var(--space-xs); flex: 1; min-width: 0; }\n\n.hx-field-label {\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--color-text-dim);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  font-family: var(--font-ui);\n  margin-bottom: 4px;\n}\n\n.hx-toggle { display: flex; gap: 4px; }\n\n.hx-toggle-btn {\n  flex: 1;\n  padding: 6px 0;\n  font-size: var(--fs-xs);\n  font-family: var(--font-ui);\n  font-weight: 600;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  border: 1px solid var(--color-border);\n  background: transparent;\n  color: var(--color-text-muted);\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n}\n.hx-toggle-btn:hover:not(:disabled) { border-color: var(--color-border-mid); }\n.hx-toggle-btn--on {\n  background: var(--color-toggle);\n  border-color: var(--color-toggle);\n  color: #fff;\n}\n.hx-toggle-btn:disabled { cursor: default; }\n.hx-toggle-btn:disabled:not(.hx-toggle-btn--on) { opacity: 0.5; }\n\n.hx-input-wrap {\n  display: flex;\n  align-items: center;\n  border: 1px solid var(--color-input-border);\n  border-radius: var(--radius-sm);\n  background: var(--color-input-bg);\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n.hx-input-wrap:focus-within {\n  border-color: var(--color-accent);\n  box-shadow: 0 0 0 3px var(--color-accent-dim);\n}\n.hx-input-wrap--disabled { background: var(--color-code-bg); opacity: 0.7; }\n\n.hx-input {\n  flex: 1;\n  min-width: 0;\n  background: transparent;\n  border: none;\n  color: var(--color-text);\n  font-family: var(--font-ui);\n  font-size: var(--fs-xs);\n  padding: 6px 8px;\n  outline: none;\n}\n.hx-input:disabled { cursor: default; }\n\n.hx-input-unit {\n  font-size: 11px;\n  color: var(--color-text-dim);\n  font-family: var(--font-ui);\n  padding: 0 8px;\n}\n\n.hx-select {\n  appearance: none;\n  width: 100%;\n  padding: 6px 28px 6px 8px;\n  background: var(--color-input-bg) url(\"data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%2393A9BC' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\") no-repeat right 9px center;\n  border: 1px solid var(--color-input-border);\n  border-radius: var(--radius-sm);\n  font-size: var(--fs-xs);\n  font-family: var(--font-ui);\n  color: var(--color-text);\n  cursor: pointer;\n  outline: none;\n}\n.hx-select:focus {\n  border-color: var(--color-accent);\n  box-shadow: 0 0 0 3px var(--color-accent-dim);\n}\n\n.hx-row { display: flex; gap: var(--space-xs); }\n\n/* ─── Buttons ────────────────────────────────────────────────── */\n.hx-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 9px 16px;\n  border-radius: var(--radius-sm);\n  border: 1px solid transparent;\n  cursor: pointer;\n  font-size: var(--fs-sm);\n  font-weight: 600;\n  font-family: var(--font-ui);\n  transition: background 0.15s, color 0.15s, border-color 0.15s, opacity 0.15s;\n  white-space: nowrap;\n}\n\n.hx-btn--ghost {\n  background: transparent;\n  border-color: var(--color-border);\n  color: var(--color-text-muted);\n  font-size: var(--fs-xs);\n}\n.hx-btn--ghost:hover { color: var(--color-text); border-color: var(--color-border-mid); }\n\n.hx-btn--primary {\n  background: var(--hx-sys);\n  color: #fff;\n  font-weight: 700;\n}\n.hx-btn--primary:hover { filter: brightness(1.08); }\n\n.hx-btn--run { flex: 1; padding: 9px 0; }\n.hx-btn:disabled { opacity: 0.65; cursor: not-allowed; }\n\n.hx-actions {\n  display: flex;\n  gap: var(--space-xs);\n  margin-top: var(--space-md);\n  flex-wrap: wrap;\n}\n.hx-actions--end { justify-content: flex-end; }\n\n/* ─── Dataset switcher ───────────────────────────────────────── */\n.hx-dstabs {\n  display: flex;\n  gap: var(--space-xs);\n  margin-bottom: var(--space-xs);\n  flex-wrap: wrap;\n}\n\n.hx-dstab {\n  padding: 4px 11px;\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  font-family: var(--font-ui);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  border: 1px solid var(--color-border);\n  background: transparent;\n  color: var(--color-text-muted);\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n}\n.hx-dstab--active {\n  border-color: var(--hx-sys);\n  background: var(--hx-sys-soft);\n  color: var(--hx-sys);\n}\n\n/* ─── Data tables ────────────────────────────────────────────────\n   Capped height + sticky header: a 20-row run can no longer push\n   the rest of the step below the fold. */\n.hx-tablewrap { overflow: auto; max-height: 340px; }\n.hx-tablewrap--short { max-height: 260px; }\n.hx-tablewrap--tall  { max-height: 440px; }\n\n.hx-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--fs-xs);\n  font-family: var(--font-ui);\n}\n\n.hx-table th {\n  text-align: left;\n  font-weight: 600;\n  color: var(--color-text-dim);\n  padding: 4px;\n  white-space: nowrap;\n  position: sticky;\n  top: 0;\n  background: var(--color-card);\n  box-shadow: inset 0 -1px 0 var(--color-border);\n  z-index: 1;\n}\n\n.hx-table td {\n  padding: 4px;\n  color: var(--color-text-muted);\n  white-space: nowrap;\n  border-top: 1px solid var(--color-border-light);\n}\n\n.hx-table tbody tr:hover td { background: var(--hx-sys-soft); }\n.hx-table .hx-td-check { width: 22px; }\n.hx-table .hx-td-name  { color: var(--color-text); }\n.hx-table .hx-th-center,\n.hx-table .hx-td-center { text-align: center; }\n\n/* Visually hidden but announced — used for the unlabelled checkbox column\n   header, which otherwise reads as an empty cell to a screen reader. */\n.hx-sr {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* ─── Chart ──────────────────────────────────────────────────── */\n.hx-chart { width: 100%; display: block; }\n.hx-chart-grid      { stroke: var(--color-border); stroke-width: 1; }\n.hx-chart-grid--v   { stroke-width: 0.5; opacity: 0.5; }\n.hx-chart-axis      { stroke: var(--color-text-dim); stroke-width: 1.2; }\n.hx-chart-tick      { fill: var(--color-text-dim); font-size: 9px; }\n.hx-chart-axislabel { fill: var(--color-text-muted); font-size: 10px; }\n.hx-chart-legend    { fill: var(--color-text-muted); font-size: 9px; }\n.hx-chart-line      { fill: none; stroke-width: 1.5; opacity: 0.75; }\n\n.hx-plot {\n  width: 100%;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--color-border);\n  display: block;\n}\n\n/* ─── Status / progress / log ────────────────────────────────── */\n.hx-progress {\n  margin-top: var(--space-xs);\n  height: 4px;\n  background: var(--color-border);\n  border-radius: 2px;\n  overflow: hidden;\n}\n.hx-progress-bar {\n  height: 100%;\n  background: var(--hx-sys);\n  transition: width 0.4s ease;\n}\n\n.hx-log {\n  font-size: 11px;\n  font-family: var(--font-mono);\n  color: var(--color-text-muted);\n  line-height: 1.6;\n  max-height: 300px;\n  overflow-y: auto;\n  white-space: pre-wrap;\n}\n\n.hx-empty {\n  color: var(--color-text-dim);\n  font-family: var(--font-ui);\n  font-size: var(--fs-xs);\n  padding: var(--space-lg) 0;\n  text-align: center;\n}\n\n.hx-error {\n  color: var(--color-error);\n  font-family: var(--font-ui);\n  font-size: var(--fs-xs);\n  line-height: 1.65;\n  padding: var(--space-sm) 0;\n}\n.hx-ok { color: var(--color-success); }\n\n/* Callout used when live edits diverge from the reference setup. */\n.hx-callout {\n  font-size: var(--fs-xs);\n  color: var(--hx-sys);\n  font-family: var(--font-ui);\n  background: var(--hx-sys-soft);\n  border: 1px solid var(--hx-sys-line);\n  border-radius: var(--radius-sm);\n  padding: 6px 9px;\n  margin-bottom: var(--space-xs);\n  line-height: 1.55;\n}\n\n/* Provenance note under a dataset table. */\n.hx-provenance {\n  font-size: var(--fs-xs);\n  color: var(--color-text-dim);\n  font-family: var(--font-ui);\n  line-height: 1.55;\n  margin-bottom: var(--space-xs);\n}\n.hx-provenance cite { font-style: normal; color: var(--color-text-muted); }\n\n/* ─── Responsive ─────────────────────────────────────────────────\n   Breakpoints mirror DataFittingPage.css (860 / 640 / 480). */\n@media (max-width: 1100px) {\n  .hx-cards { grid-template-columns: 1fr; }\n}\n\n@media (max-width: 860px) {\n  .hx-main {\n    margin-left: 0;\n    width: 100%;\n  }\n  .hx-scroll { padding: var(--space-md); }\n  .hx-2col,\n  .hx-3col { grid-template-columns: 1fr; }\n  .hx-ref {\n    text-align: left;\n    max-width: none;\n  }\n}\n\n@media (max-width: 640px) {\n  .hx-title { font-size: var(--fs-lg); }\n  .hx-row { flex-direction: column; gap: 0; }\n  .hx-tablewrap,\n  .hx-tablewrap--short,\n  .hx-tablewrap--tall { max-height: 300px; }\n}\n\n@media (max-width: 480px) {\n  .hx-actions { flex-direction: column; align-items: stretch; }\n  .hx-btn { width: 100%; }\n  .hx-step { flex: 1 1 45%; }\n}\n\n/* ─── Reduced motion ─────────────────────────────────────────── */\n@media (prefers-reduced-motion: reduce) {\n  .hx-card,\n  .hx-panel { animation: none; }\n  .hx-card:hover { transform: none; }\n  .hx-progress-bar { transition: none; }\n}\n\n/* ─── Print ──────────────────────────────────────────────────── */\n@media print {\n  .hx-root { position: static; height: auto; }\n  .hx-main { margin-left: 0; width: 100%; }\n  .hx-scroll { overflow: visible; margin-top: 0; }\n  .hx-tablewrap,\n  .hx-tablewrap--short,\n  .hx-tablewrap--tall { max-height: none; overflow: visible; }\n  .hx-steps, .hx-actions, .hx-tabs { display: none; }\n}\n\n/* Iglesia 2008 review-example indicators. This is deliberately an amber/\n   neutral warning rather than a red error: the example is runnable for\n   platform validation but is not yet approved as a paper-faithful model. */\n.hx-tag--warning {\n  color: #B7770D;\n  background: rgba(243,156,18,0.10);\n  border-color: rgba(243,156,18,0.28);\n}\n\n.hx-review-banner {\n  margin-top: 7px;\n  padding: 8px 10px;\n  border: 1px solid rgba(243,156,18,0.28);\n  border-radius: var(--radius-sm);\n  background: rgba(243,156,18,0.08);\n  color: #B7770D;\n  font-size: var(--fs-xs);\n  font-family: var(--font-ui);\n  line-height: 1.5;\n  max-width: 90ch;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
